export default __webpack_public_path__ + "static/media/img2.10100f70.png";